import { Widget, WIDGET_ROSTER } from "@gaming/srvg-classes-core";

export class RosterWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#rosterWidget';
        super( options );

        this.name = 'widgetroster';
        this.widgetName = options.widgetName || WIDGET_ROSTER;
        this.widgetName = this.product + this.widgetName;


        this.widget = null;

        this.widgetOptions = {
            height: this.getContainerHeightWithUnit(),
            showTeamAbbr: false,
            showUpcomingRounds: "placeholder"
        };

        //if(srvg && srvg.config && srvg.config.modeItaly && srvg.config.modeItaly === true){
        this.widgetOptions.show3rdPlace = true;
        //}


        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addCuprosterWidget();
        super.handleDomInstantiated();
    }

    /**
     * add cuproster widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addCuprosterWidget(selector?) {
        var that = this;
        selector = selector || this.selector;
        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addCuprosterWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(selector, eventdata){
        this.addCuprosterWidget(selector);
    }


    /**
     * calls widget api setChannel to switch channel
     * it is not necessary to switch the channel if livescore widget is connected with widget via widget group
     * @param number channel equivalent to videochannel
     */
    setChannel(channel?: number){
        if(this.widget.api){
            this.widget.api.setChannel(channel);
        }
    }

}